import React, { MouseEvent, ReactNode, useEffect } from 'react'

import * as Bridge from '@/api/BridgeApi'
import { FadeTransition } from '@/components/common/transition/FadeTransition'
import { STATUS_BAR_COLOR } from '@/domains/CommonDomain'
import { isDimmedClick } from '@/utils/domUtils'

interface IWrapperProps {
  children: ReactNode
  isOpen: boolean
  isDebitCardHistory?: boolean
  close: () => void
  useTransition?: boolean
}

export const Wrapper = (props: IWrapperProps) => {
  const { useTransition = false, isDebitCardHistory = false } = props
  const wrapperClassName = 'ly'
  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    if (isDimmedClick(e, wrapperClassName)) {
      props.close()
    }
  }

  useEffect(() => {
    let backgroundColor = isDebitCardHistory
      ? STATUS_BAR_COLOR.DEBIT_CARD_HISTORY
      : STATUS_BAR_COLOR.DEFAULT

    if (props.isOpen) {
      backgroundColor = isDebitCardHistory
        ? STATUS_BAR_COLOR.DEBIT_CARD_HISTORY_DIMMED
        : STATUS_BAR_COLOR.DIMMED
    }

    Bridge.changeStatusBar({ backgroundColor })

    return () => {
      Bridge.changeStatusBar({ backgroundColor: STATUS_BAR_COLOR.DEFAULT })
    }
  }, [isDebitCardHistory, props.isOpen])

  if (!useTransition) {
    return (
      <div
        className={wrapperClassName}
        onClick={onClick}
        style={{ display: props.isOpen ? 'block' : 'none' }}
      >
        {props.children}
      </div>
    )
  }

  return (
    <FadeTransition in={props.isOpen}>
      <div className={wrapperClassName} onClick={onClick}>
        {props.children}
      </div>
    </FadeTransition>
  )
}
